import React, { useEffect, useState } from 'react';
import api from '../services/api';

const STORAGE_KEY = 'lastSellerId';

export const leerUltimoVendedor = () => {
    try {
        return localStorage.getItem(STORAGE_KEY) || '';
    } catch (e) {
        return '';
    }
};

/**
 * Selector "Vendido por": lista los trabajadores activos.
 * Recuerda en este equipo el último trabajador elegido.
 */
const SelectorVendedor = ({ value, onChange, compact = false }) => {
    const [workers, setWorkers] = useState([]);

    useEffect(() => {
        let cancelled = false;
        api.get('/api/orders/workers/', {
            baseURL: process.env.REACT_APP_FAST_FOOD_SERVICE,
            params: { is_active: 'true' }
        }).then(res => {
            if (cancelled) return;
            const list = Array.isArray(res.data) ? res.data : (res.data.results || []);
            setWorkers(list);
            // Si el trabajador recordado ya no está activo, limpiar la selección
            if (value && !list.some(w => w.id === value)) onChange('');
        }).catch(err => console.error('Error cargando trabajadores:', err));
        return () => { cancelled = true; };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleChange = (id) => {
        try {
            if (id) localStorage.setItem(STORAGE_KEY, id);
            else localStorage.removeItem(STORAGE_KEY);
        } catch (e) { /* almacenamiento no disponible */ }
        onChange(id);
    };

    return (
        <div style={{ marginBottom: compact ? 0 : '16px' }}>
            <label style={{ display: 'block', fontSize: '13px', fontWeight: '600', color: 'var(--text-primary)', marginBottom: '6px' }}>
                <i className="bi bi-person-badge" style={{ color: 'var(--primary-color)', marginRight: '4px' }}></i> Vendido por
            </label>
            <select
                value={value || ''}
                onChange={(e) => handleChange(e.target.value)}
                style={{
                    width: '100%', padding: '10px 14px', borderRadius: '8px',
                    border: `1px solid ${value ? 'var(--border-color)' : '#fcd34d'}`, fontSize: '14px',
                    backgroundColor: 'white', color: 'var(--text-primary)', outline: 'none'
                }}
            >
                <option value="">Sin asignar</option>
                {workers.map(w => <option key={w.id} value={w.id}>{w.name}</option>)}
            </select>
            {workers.length === 0 && (
                <div style={{ fontSize: '11px', color: '#64748b', marginTop: '4px' }}>
                    Agrega trabajadores en el menú <strong>Trabajadores</strong>.
                </div>
            )}
        </div>
    );
};

export default SelectorVendedor;
